import { Component, ViewEncapsulation, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InformationDialogConfig, HtmlContent } from '../information-dialog/information-dialog.component';
import { ApMatDialogService } from '../../services';
import { isNullOrEmpty } from '@awp/core/utils';

export interface ConfirmationDialogConfig extends InformationDialogConfig {
  confirmLabel: HtmlContent;
}

export function showConfirmationDialog(dialogService: ApMatDialogService, config: ConfirmationDialogConfig): MatDialogRef<ConfirmDialogComponent, any> {
  const panelClass = config.panelClass != null ? config.panelClass.split(' ').filter(p => !isNullOrEmpty(p)) : [];
  const parentClass = config.parentClass != null ? config.parentClass.split(' ').filter(p => !isNullOrEmpty(p)) : [];

  return dialogService.open(ConfirmDialogComponent, {
      data: {
        ...config,
        parentClass,
        showCloseButton: config.showCloseButton
      },
      disableClose: !config.showCloseButton,
      panelClass: ['ap-dialog', 'ap-confirmation-dialog', ...panelClass]
    }
  );
}


@Component({
  selector: 'ap-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent {

  showCloseButton = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogConfig) {
    this.showCloseButton = data.showCloseButton == null ? true : data.showCloseButton;
  }

}
